<template>
  <div
    v-if="type === MARKET_LIST_TYPES.WITH_BACKBOX"
    class="text-static-success-hi"
  >
    {{ i18n(translations.hasBackbox) }}
  </div>

  <div v-if="type === MARKET_LIST_TYPES.WITHOUT_BACKBOX">
    <span v-if="item.hasBackboxWithOtherListing">
      {{ i18n(translations.hasBackboxWithOtherListing) }}
    </span>

    <span v-else class="text-static-danger-hi">
      {{
        i18n(translations.belowBackboxPrice, {
          price: item.backboxPriceLabel,
        })
      }}
    </span>
  </div>

  <FormattedMessage
    v-if="type === MARKET_LIST_TYPES.OFFLINE"
    class="text-static-danger-hi"
    :definition="translations.warningOffline"
  >
    <template #cta>
      <RevLink @click="handleOpenListingDetail">
        <span class="text-static-danger-hi">{{
          i18n(translations.warningOfflineCta)
        }}</span>
      </RevLink>
    </template>
  </FormattedMessage>
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import {
  QUERY_MODAL_NAME,
  QUERY_MODAL_TAB_NAME,
  TABS_INFO,
} from '~/scopes/listings/pages/index/components/ListingDetailsDrawer/ListingDetailsDrawer.constants'

import { MARKET_LIST_TYPES } from '../MarketList.constants'
import translations from '../MarketList.translations'

const i18n = useI18n()
const route = useRoute()

const props = defineProps<{
  listingId: string
  type: string
  item: Record<string, unknown>
}>()

async function handleOpenListingDetail() {
  await navigateTo({
    ...route,
    query: route.query,
    hash: `#${QUERY_MODAL_NAME}=${props.listingId}#${QUERY_MODAL_TAB_NAME}=${TABS_INFO[0].tabName}`,
    replace: true,
  })
}
</script>
